import React, { useContext, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

import AuthService from '../../../../services/AuthService'
import { ToastsContext } from '../../../../contexts/ToastsContext'
import useOutsideClick from '../../../../hooks/useOutsideClick'
import CheckmarkSVG from '../../../svg/CheckmarkSVG'

const CountriesDropdown = ({ getValues, setValue, isFormSubmitted }) => {
  const [countriesList, setCountriesList] = useState([])

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const menuRef = useRef(null)
  const effectRan = useRef(false)

  const { setToasts } = useContext(ToastsContext)

  const selectCountry = (country) => {
    setValue('selectedCountry', country)
    setIsMenuOpen(false)
  }

  useEffect(() => {
    if (effectRan.current === false) {
      AuthService.getCountries()
        .then((res) => {
          setCountriesList(
            res.data
              .map((country) => ({
                text: country.name.common,
                image: country.flags.svg,
                code: country.cca2,
              }))
              .sort((a, b) => a.text.localeCompare(b.text))
          )
        })
        .catch((e) => {
          console.error(e?.response?.data?.message)
          setToasts([e?.response?.data?.message])
        })
      return () => {
        effectRan.current = true
      }
    }
  }, [])

  useOutsideClick({
    dependency: getValues('selectedCountry'),
    ref: menuRef,
    setClosed: setIsMenuOpen,
  })
  return (
    <div className="relative mb-1">
      <div ref={menuRef}>
        <button
          type="button"
          className={clsx(
            'relative py-1.5 pl-[16px] pr-[25px] w-full h-[34px] taller:h-[40px] flex items-center text-white text-sm taller:text-base font-light text-left appearance-none truncate shadow-[4px_4px_10px_0px_#00000040] rounded-xl',
            {
              'bg-blue':
                (!isFormSubmitted && !getValues('selectedCountry').code) ||
                getValues('selectedCountry').code,
              'bg-red/60':
                isFormSubmitted && !getValues('selectedCountry').code,
            }
          )}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {getValues('selectedCountry').image ? (
            <img
              src={getValues('selectedCountry').image}
              className="w-[18px] pointer-events-none"
              alt=""
            />
          ) : (
            ''
          )}
          <p className="ml-2">{getValues('selectedCountry').text}</p>
          <svg
            className="absolute right-[12px] cursor-pointer pointer-events-none"
            width="11"
            height="9"
            viewBox="0 0 11 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={isMenuOpen ? 'rotate(180)' : 'rotate(0)'}
          >
            <path
              d="M5.5 9L0.736861 0.749999L10.2631 0.75L5.5 9Z"
              fill="#0C1A35"
            />
          </svg>
        </button>
        <ul
          className={clsx(
            'absolute w-full max-h-[260px] bg-blue overflow-y-scroll rounded-md top-[110%] z-10 shadow-[4px_4px_10px_0px_#00000040]',
            {
              hidden: !isMenuOpen,
            }
          )}
          onClick={(e) => e.stopPropagation()}
        >
          {countriesList.map((item, index) => (
            <li
              key={item.text}
              className={clsx(
                'flex items-center text-white text-sm taller:text-base font-light hover:bg-blue-hover',
                {
                  'rounded-t-md': index === 0,
                  'rounded-b-md': index === countriesList.length - 1,
                }
              )}
            >
              {getValues('selectedCountry').text === item.text && (
                <CheckmarkSVG size={14} />
              )}
              <button
                type="button"
                className={clsx('text-left pl-[16px] pr-[5px] py-1 w-full', {
                  'flex items-center gap-1': item.image,
                })}
                onClick={() => selectCountry(item)}
              >
                {item.image && (
                  <img
                    src={item.image}
                    className="w-[18px] pointer-events-none"
                    alt=""
                  />
                )}
                <p className="truncate pl-1">{item.text}</p>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default CountriesDropdown
